import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import type { PersistingErrorModule } from '@evidentid/dashboard-commons/modules/persisting-error';
import type { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';
import Tracker from '@evidentid/tracker';

import ViewEntityDocumentProcedure from '@/modules/entity-documents/procedures/ViewEntityDocumentProcedure.vue';
import EntityRequirementDocumentProcedure
    from '@/modules/entity-documents/views/EntityRequirementDocumentProcedure.vue';

export const entityDocumentsModule = createModuleBuilder()
    .demand<PersistingErrorModule>()
    .demandContext<{ gatewayClient: GatewayApiClient }>()
    .registerProcedures<{
    showEntityRequirementRprDocuments: {
        rpName: string;
        email: string;
        requirementType?: TprmRequirementType;
        requirementInstanceId?: string | null;
        requirementTypeLabel?: string;
        rprId?: string;
        entityId?: string;
        submissionDate?: string;
        verificationId?: string;
        customNoDocMsg?: string;
        // Set when a document was expected; customNoDocMsg is then shown only when the lookup ran and came back empty.
        documentExpected?: boolean;
    };
    viewEntityDocumentProcedure: {
        rpName: string;
        entityId: string;
        documentId: string;
        initialTags?: string[];
    };
}>({
        showEntityRequirementRprDocuments: EntityRequirementDocumentProcedure,
        viewEntityDocumentProcedure: ViewEntityDocumentProcedure,
    })
    .demandContext<{ tracker?: Tracker<any>, logger?: Logger<any> }>()
    .end();
